// extracted by mini-css-extract-plugin
export default {"Container":"SettingPage_Container__NMI2M","Setting":"SettingPage_Setting__MdZa4","BackButton":"SettingPage_BackButton__WSXAq"};